<template>
  <div class="footer">
    <div class="foot-cont">
      <router-link to="/" class="logo-f">
        <img :src="require('@/assets/images/logo_foot.png')" alt="人人动画网">
      </router-link>
      <div class="infoes">
        <ul class="nav clearfix">
          <li><router-link to="/">首页</router-link></li>
          <li><router-link to="/about">关于</router-link></li>
          <li><router-link to="/coop">合作</router-link></li>
          <li><a href="http://www.wemeie.com/" target="_blank">薇米云</a></li>
          <li><router-link to="/">iClone</router-link></li>
        </ul>
        <div class="line-through">
          <!-- <img @click="toTop" title="回到顶部" class="back-top" :src="require('@/assets/images/back_top.png')" alt=""> -->
        </div>
        <!-- <transition name="fade">
          <div class="back-top-new" @click="toTop" v-if="showBackTop">
            <img title="回到顶部" :src="require('@/assets/images/back_top2.png')" alt="">
          </div>
        </transition> -->
        <div class="contact-links clearfix">
          <div class="item">
            <div class="tit"><span>联系我们</span><span> / CONTACT US</span></div>
            <p>电话：010-65803688</p>
            <p>Email：rrdh@21teacher.com</p>
            <p>地址：北京市丰台区国投财富广场3号楼1018室</p>
          </div>
          <div class="item">
            <div class="tit"><span>友情链接</span><span> / FRIENDSHIP LINK</span></div>
            <p><a target="_blank" href="http://www.quick3d.com.cn/">北京超视界科技有限公司</a></p>
            <p><a href="javascript:;">北京超视界影视传媒有限公司</a></p>
            <p><a target="_blank" href="http://www.idredu.com/">北京艾迪尔文创科技有限公司</a></p>
          </div>
          <div class="item qrs clearfix">
            <div class="qr-itm">
              <img :src="require('@/assets/images/side_qr_01.jpg')" alt="">
              <p class="qr-t">观影厅小程序</p>
            </div>
            <div class="qr-itm">
              <img :src="require('@/assets/images/side_qr_04.jpg')" alt="">
              <p class="qr-t">人人动画APP</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="beian">
      <a class="item" href="http://beian.miit.gov.cn" target="_blank">京ICP备16018200号-3</a>
      <router-link class="item" to="/netpassport" target="_blank">增值电信业务经营许可证</router-link>
      <router-link class="item" to="/business" target="_blank">营业执照</router-link>
      <router-link class="item" to="/publication" target="_blank">出版物经营许可证</router-link>
    </div>
    <transition name="fade">
      <ul class="new-side-btns" v-if="showBackTop">
        <el-popover
          placement="left-start"
          trigger="hover"
          popper-class="side-wrap-popper-class"
        >
          <div class="side-qr-list clearfix">
            <div class="qr-item">
              <img :src="require('@/assets/images/side_qr_01.jpg')" alt="">
              <p class="tit">观影厅小程序</p>
            </div>
            <div class="qr-item">
              <img :src="require('@/assets/images/side_qr_04.jpg')" alt="">
              <p class="tit">人人动画APP</p>
            </div>
            <div class="qr-item">
              <img :src="require('@/assets/images/side_qr_03.jpg')" alt="">
              <p class="tit">微信公众号</p>
            </div>
          </div>
          <li slot="reference" class="side-item qr"></li>
        </el-popover>
        <el-popover
          placement="left-start"
          trigger="click"
          popper-class="side-wrap-popper-class chat-wrapper"
          @hide="hideChatDiv('1')"
          @show="isLogin ?showChatDiv('1'):notLogin()"
        >
          <div class="contact-serve-wrap" v-if="isLogin">
            <chat-wrap v-if="reLoadChat1"/>
          </div>
          <li slot="reference" class="side-item serve only-pc-show"></li>
        </el-popover>
        <li slot="reference" class="side-item serve only-phone-show" @click="showPhoneChat"></li>
        <li @click="toIdea" class="side-item idea" title="意见反馈"></li>
        <li class="side-item top" @click="toTop" title="返回顶部"></li>
      </ul>
    </transition>
    <transition name="fade">
      <ul class="new-side-btns" v-if="!showBackTop">
        <el-popover
          placement="left-start"
          trigger="hover"
          popper-class="side-wrap-popper-class"
        >
          <div class="side-qr-list clearfix">
            <div class="qr-item">
              <img :src="require('@/assets/images/side_qr_01.jpg')" alt="">
              <p class="tit">观影厅小程序</p>
            </div>
            <div class="qr-item">
              <img :src="require('@/assets/images/side_qr_04.jpg')" alt="">
              <p class="tit">人人动画APP</p>
            </div>
            <div class="qr-item">
              <img :src="require('@/assets/images/side_qr_03.jpg')" alt="">
              <p class="tit">微信公众号</p>
            </div>
          </div>
          <li slot="reference" class="side-item qr"></li>
        </el-popover>
        <el-popover
          placement="left-start"
          trigger="click"
          popper-class="side-wrap-popper-class chat-wrapper"
          @hide="hideChatDiv('2')"
          @show="isLogin ?showChatDiv('2'):notLogin()"
        >
          <div class="contact-serve-wrap" v-if="isLogin">
            <chat-wrap v-if="reLoadChat2"/>
          </div>
          <li slot="reference" class="side-item serve only-pc-show"></li>
        </el-popover>
        <li slot="reference" class="side-item serve only-phone-show" @click="showPhoneChat"></li>
        <li @click="toIdea" class="side-item idea" title="意见反馈"></li>
      </ul>
    </transition>
    <el-dialog
      :visible.sync="dialogChat"
      fullscreen
      custom-class="phone-chat-wrapper"
      lock-scroll
    >
      <chat-wrap />
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import chatWrap from './chat'
export default {
  components: {
    chatWrap
  },
  data () {
    return {
      showBackTop: false,
      dialogChat: false,
      reLoadChat1:false,
      reLoadChat2:false,
      isLogin:false,
    }
  },
  mounted () {



    window.addEventListener('scroll', () => {
      var top = document.documentElement.scrollTop || document.body.scrollTop
      // console.log(top)
      if(top >= 100){
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }
    })
    setTimeout(()=>{
      this.setLogin();
    },500)


  },
  methods: {
    setLogin() {
      this.isLogin = this.global.isLogin

      console.log("=isLogin===================",this.isLogin)
    },
    notLogin(){
      this.$message.error("请先登录")
    },
    hideChatDiv(numberCode){
      console.log("=========hideChatDiv=========",numberCode)
      if(numberCode == '1'){
        this.reLoadChat1 = false
        // this.$nextTick(() => {
        //   this.reLoadChat1 = true
        // })
      }else{
        this.reLoadChat2 = false
        // this.$nextTick(() => {
        //   this.reLoadChat2 = true
        // })
      }
    },
    showChatDiv(numberCode){
      console.log("=========showChatDiv=========",numberCode)
      if(numberCode == '1'){
        this.reLoadChat1 = false
        this.$nextTick(() => {
          this.reLoadChat1 = true
        })
      }else{
        this.reLoadChat2 = false
        this.$nextTick(() => {
          this.reLoadChat2 = true
        })
      }

    },
    toTop () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    },
    toIdea() {
      window.open("http://www.renrendonghua.com/idea","_blank")
    },
    showPhoneChat () {
      this.dialogChat = true
    }
  }
}
</script>


<style lang="less">
.side-wrap-popper-class{
  width: auto;
  padding: 20px;
  .side-qr-list{
    .qr-item{
      float: left;
      width: 130px;
      margin: 0 10px;
      // height: 100px;
      img{
        width: 100%;
        // margin: 0 auto;
      }
      p.tit{
        // margin-top: 10px;
        line-height: 20px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  &.chat-wrapper {
    padding: 2px !important;
  }
}
.phone-chat-wrapper {
  .el-dialog__header {
    position: absolute;
    z-index: 1;
    width: 100%;
    .el-dialog__close {
      color: #fff;
    }
  }
  .el-dialog__body {
    height: 100vh;
    padding: 5px;
  }
}
</style>
<style scoped lang="less">
.footer{
  overflow: hidden;
  width: 100%;
  color: #8b8b8b;
  font-size: 14px;
  background: #252525;
  .foot-cont{
    display: flex;
    padding: 40px 0;
    margin: 0 auto;
    .logo-f{
      display: block;
      height: @NAVHEIGHT;
      img{
        display: block;
        height: 100%;
      }
    }
    .infoes{
      flex: 1;
      .nav{
        padding-bottom: 15px;
        // border-bottom: 1px solid #8b8b8b;
        li{
          position: relative;
          float: left;
          padding: 0 35px;
          line-height: 24px;
          font-size: 16px;
          a{
            color: #8b8b8b;
          }
          &:after{
            position: absolute;
            right: 0;
            top: 0;
            content: '/';
            display: block;
            line-height: 24px;
            font-size: 18px;
          }
          &:first-child{
            padding-left: 0;
          }
          &:last-child{
            &:after{
              display: none;
            }
          }
        }
      }
      .line-through{
        position: relative;
        &:after{
          position: absolute;
          content: '';
          display: block;
          width: 100vw;
          height: 1px;
          background: #575757;
        }
        .back-top{
          position: absolute;
          z-index: 1;
          top: -52px;
          cursor: pointer;
        }
      }
      .back-top-new{
        position: fixed;
        z-index: 1;
        right: 50%;
        bottom: 100px;
        width: 40px;
        cursor: pointer;
      }
      .contact-links{
        padding-top: 40px;
        .item{
          float: left;
          width: 30%;
          margin-top: 10px;
          .tit{
            font-size: 15px;
          }
          p{
            margin-top: 10px;
            font-size: 12px;
            color: #717171;
          }
          &.qrs{
            width: 35%;
            margin-top: 0;
            .qr-itm{
              float: left;
              width: 30%;
              margin-right: 10%;
              &:last-child{
                margin-right: 0;
              }
              img{
                width: 100%;
              }
              .qr-t{
                margin-top: 5px;
                font-size: 14px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .beian{
    padding: 15px 0;
    // height: 55px;
    line-height: 25px;
    text-align: center;
    background: #1c1c1c;
    .item{
      margin-right: 20px;
      font-size: 14px;
      &:hover{
        text-decoration: underline;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
  .new-side-btns{
    position: fixed;
    z-index: 5;
    right: 30px;
    bottom: 30px;
    background: #fff;
    .side-item{
      display: block;
      width: 50px;
      height: 50px;
      // background-image: url('../../../assets/images/side_icon_02_active.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 70%;
      cursor: pointer;
      &.qr{
        background-image: url('../../../assets/images/side_icon_01_active.png');
      }
      &.idea{
        background-image: url('../../../assets/images/side_icon_03_active.png');
      }
      &.top{
        background-image: url('../../../assets/images/side_icon_02_active.png');
      }
      &.serve{
        background-image: url('../../../assets/images/side_icon_04_active.png');
      }
      &:hover{
        background-color: #ec424e;
        &.qr{
          background-image: url('../../../assets/images/side_icon_01.png');
        }
        &.idea{
          background-image: url('../../../assets/images/side_icon_03.png');
        }
        &.top{
          background-image: url('../../../assets/images/side_icon_02.png');
        }
        &.serve{
          background-image: url('../../../assets/images/side_icon_04.png');
        }
      }
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.contact-serve-wrap {
  width: 300px;
  height: 500px;
}
@media screen and (max-width: 750px) {
  .footer{
    padding: 0 10px;
    .foot-cont{
      flex-direction: column;
      .logo-f{
        margin-bottom: 20px;
        img{
          margin: 0 auto;
        }
      }
      .infoes{
        margin-left: 0;
        .nav{
          text-align: center;
          font-size: 0;
          li{
            float: none;
            display: inline-block;
            padding: 0 10px;
            &:after{
              right: -3px;
            }
          }
        }
        .line-through{
          &:after{
            width: 100%;
          }
          .back-top{
            right: 10px;
          }
        }
        .back-top-new{
          margin: 0;
          right: 10px;
          bottom: 10px;
        }
        .contact-links{
          padding-top: 10px;
          .item{
            width: 100%;
            padding-left: 40px;
            margin-top: 0;
            margin-bottom: 20px;
            &:last-child{
              margin-bottom: 0;
            }
            .tit{
              font-size: 14px;
              span:last-child{
                display: none;
              }
            }
            &.qrs{
              width: 100%;
              padding-right: 40px;
            }
          }
        }
      }
    }
    .new-side-btns {
      right: 10px;
      bottom: 10px;
      box-shadow: 0 0 5px 0 #ccc;
    }
  }
}
@media screen and (min-width: 751px) {
  .footer{
    .foot-cont{
      width: 700px;
      .infoes{
        margin-left: 30px;
        .line-through{
          .back-top{
            right: 0;
          }
        }
        .back-top-new{
          margin-right: -250px;
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .footer{
    .foot-cont{
      width: 1000px;
      .infoes{
        margin-left: 50px;
        .line-through{
          .back-top{
            right: 50px;
          }
        }
        .back-top-new{
          margin-right: -400px;
        }
      }
    }
  }
}
@media screen and (min-width: 1250px) {
  .footer{
    .foot-cont{
      width: 1200px;
      .infoes{
        .line-through{
          .back-top{
            right: 100px;
          }
        }
        .back-top-new{
          margin-right: -500px;
        }
      }
    }
  }
}
</style>
